export enum ScreenType {
  OffCyclePayments = 1,
  PaymentHistory = 2,
  CompleteOffCyclePayment = 3,
}
